module.exports = __webpack_public_path__ + "img/level_spacing.00660fd4.svg";